import React from "react";
import { BiChevronLeft, BiCopy } from "react-icons/bi";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router";
import { getShippingDetails, updateShippingDetail } from "../../api/ship";
import { Skeleton } from "antd";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import { format } from "date-fns";

const status = [
  { label: "Pending", value: "pending" },
  { label: "Shpped", value: "shipped" },
  { label: "In Transit", value: "in_transit" },
  { label: "Delivered", value: "delivered" },
  { label: "Need Attention", value: "need_attention" },
  { label: "Awaiting Payment", value: "awaiting_payment" },
  { label: "Canceled", value: "cancel" },
];

const ShoppingDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery(["shipping-details", id], () =>
    getShippingDetails(id)
  );

  const mutation = useMutation(updateShippingDetail, {
    onMutate: () => showSuccessToast("Updating shipping status..."),
    onSuccess: () => {
      queryClient.invalidateQueries("shipping-details");
      queryClient.invalidateQueries("shipping-records");
      showSuccessToast("Shipping status updated")
    },
    onError: (e) => showErrorToast(e.message),
  });

  return (
    <div className="p-5 font-dmsans">
      {isLoading ? (
        <div className="flex flex-col gap-5">
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      ) : (
        <div className="flex flex-col gap-5 mb-16">
          <div className="flex items-center gap-3">
            <BiChevronLeft
              className="text-[#070E05] text-[25px] cursor-pointer"
              onClick={(e) => navigate(`/shipping`)}
            />
            <div className=" font-Neurial font-bold text-[20px] text-[#070E05]">
              Shipping details
            </div>
          </div>
          <div className="w-full flex gap-4">
            <div className="w-7/12 bg-white rounded-lg p-4 flex flex-col gap-4">
              <div className="font-bold text-[17px] font-Neurial flex items-center gap-4">
                <div>
                  Tracking ID{" "}
                  <span className="text-[#2121F1] truncate break-words">
                    #{data?._id || data?.id}
                  </span>
                </div>
                <BiCopy size={25} />
              </div>

              <div className="flex flex-col gap-6">
                <div className="flex justify-between">
                  <p>Product</p>
                  <p>{data?.pkg?.description}</p>
                </div>
                <div className="flex justify-between">
                  <p>Category</p>
                  <p>{data?.pkg?.category}</p>
                </div>
                <div className="flex justify-between">
                  <p>Weight</p>
                  <p>{data?.pkg?.weight}</p>
                </div>
                <div className="flex justify-between">
                  <p>Type</p>
                  <p>{data?.pkg?.type}</p>
                </div>
                <div className="flex justify-between">
                  <p>Receipt</p>
                  <p></p>
                </div>
                <div className="flex justify-between">
                  <p>Order Created</p>
                  <p>{new Date(data.createdAt).toLocaleDateString()}</p>
                </div>
                <div className="flex justify-between">
                  <p>Order Time</p>
                  <p>{format(new Date(data.createdAt), 'h:mmaaa')}</p>
                </div>
              </div>
            </div>
            <div className="w-7/12 flex flex-col gap-4">
              <div className="flex flex-col gap-6 bg-white rounded-lg p-4">
                <div className="flex justify-between">
                  <p>Shipment status</p>
                  <select
                    onChange={(val) => {
                      console.log({ val: val.target.value });
                      mutation.mutate({ id, shipmentStatus: val.target.value })
                    }}
                    value={data?.status}
                    className="border-[1px] border-black rounded-lg p-2"
                  >
                    {status.map((st) => (
                      <option value={st.value}>{st.label}</option>
                    ))}
                  </select>
                </div>
                <div className="flex justify-between">
                  <p>Delivery cost</p>
                  <p>{data?.payment?.deliveryFee}</p>
                </div>
                <div className="flex justify-between">
                  <p>Payment status</p>
                  <p>{data?.payment?.isPaid ? "Paid" : "Not Paid"}</p>
                </div>
              </div>

              <div className="flex flex-col gap-6 bg-white rounded-lg p-4">
                <p className="font-bold text-lg">Customer Details</p>
                <div className="flex justify-between">
                  <p>Customer Name</p>
                  <p>{data?.receiver?.name}</p>
                </div>
                <div className="flex justify-between">
                  <p>Email</p>
                  <p>{data?.receiver?.email}</p>
                </div>
                <div className="flex justify-between">
                  <p>Phone Number</p>
                  <p>{data?.receiver?.phoneNumber}</p>
                </div>
                <div className="flex justify-between">
                  <p>Location/Address</p>
                  <p>{data?.receiver?.pickupLocation}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShoppingDetails;
